import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b2ba0a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "is-flex is-flex-direction-column" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "main loaded mt-6 pb-6 pl-6 pr-6 pt-10"
}

import { useRoute, useRouter } from 'vue-router'
import { onMounted, ref } from 'vue'
import browser from 'webextension-polyfill'

import { InternalMethods } from '@/shared/apis/messages'
import Button from '@/popup/components/shared/Button.vue'
import { useGlobals } from '@/popup/compositions/useGlobals'
import { Identicon } from '@/shared/models/Identicon'
import { useApprovalsStore } from '@/popup/store/ApprovalsStore'
import IconButton from '@/popup/components/shared/IconButton.vue'
import { Approval, ApprovalApi } from '@/shared/apis/approvals'
import { upGenerateLSP23addressRequest } from '@/shared/models/GenerateLSP23address'
import Identicons from '@/popup/components/views/Onboard/CreateAddress/Identicons.vue'
import { useWeb3Eth } from '@/popup/compositions/useWeb3Eth'
import { assertNotUndefined } from '@/shared/validators'
import getBase64FromUrl from '@/shared/getBase64FromUrl'
import { PopupDatabase } from '@/popup/storage/Database'
import ApprovalHeader from '@/popup/components/shared/ApprovalHeader.vue'
import Sanitize from '@/popup/components/shared/Sanitize.vue'
import { removeSchemaFromUrl, truncateMiddle } from '@/shared/utils'
import { redirectAfterApproval } from '@/popup/utils/redirectAfterApproval'
import { useAppStore } from '@/popup/store/AppStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateAddress',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const globals = useGlobals()
const appStore = useAppStore()
const web3Eth = useWeb3Eth().getWeb3Eth()
const controllerAddress = ref('')
const approvalsStore = useApprovalsStore()

const approvalId = route.params['id']
  ? (route.params['id'] as string)
  : undefined

const approval: undefined | Approval<keyof ApprovalApi, unknown> = approvalId
  ? approvalsStore.getApproval(approvalId)
  : undefined

const upGenerateLSP23AddressParams =
  approval?.requestData as upGenerateLSP23addressRequest

const identicon = ref<Identicon>()

const confirmAddress = async () => {
  assertNotUndefined(identicon.value)
  await globals.sendMessage({
    method: InternalMethods.CONFIRM_LSP23_ADDRESS,
    payload: {
      controllerAddress: controllerAddress.value,
      requestId: approval?.id,
      identicon: { ...identicon.value, icon: '' },
    },
  })
  window.close()
}

const openLSP23Link = () => {
  browser.tabs.create({
    url: 'https://docs.lukso.tech/standards/generic-standards/lsp23-linked-contracts-factory',
  })
}

const updateIdenticon = (identiconModel: Identicon) => {
  assertNotUndefined(identicon)
  identicon.value = identiconModel
}

const onCancel = async () => {
  await globals.sendMessage({
    method: InternalMethods.CONFIRM_LSP23_ADDRESS,
    payload: {
      requestId: approval?.id,
      identicon: undefined,
      controllerAddress: controllerAddress.value,
    },
  })

  if (approval?.id) {
    approvalsStore.deleteApproval(approval.id)
  }

  redirectAfterApproval(
    router,
    approvalsStore.nonStashedApprovals.length,
    appStore.lastPopupState?.path
  )
}

onMounted(async () => {
  const icon = upGenerateLSP23AddressParams.icon
  if (approval?.origin) {
    const originMeta = {
      url: encodeURI(approval.origin),
      icon: icon && (await getBase64FromUrl(icon)),
    }
    await PopupDatabase.put('origins', originMeta)
  }
  controllerAddress.value = await globals.sendMessage({
    method: InternalMethods.CREATE_CONTROLLER,
    payload: undefined,
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(ApprovalHeader, {
        icon: _unref(upGenerateLSP23AddressParams).icon
      }, {
        subtitle: _withCtx(() => [
          _createVNode(Sanitize, {
            html: _unref(truncateMiddle)(_unref(removeSchemaFromUrl)(_unref(approval)?.origin), 25)
          }, null, 8 /* PROPS */, ["html"])
        ]),
        actions: _withCtx(() => [
          _createVNode(IconButton, {
            tooltip: _ctx.$t('sign.cancel'),
            onOnClick: onCancel
          }, null, 8 /* PROPS */, ["tooltip"])
        ]),
        title: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('create_address.title')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["icon"]),
      _createElementVNode("div", {
        onClick: openLSP23Link,
        class: "create-account-title mx-6 mt-2"
      }, [
        _createElementVNode("div", {
          innerHTML: _ctx.$t('create_address.description', { lsp23: 'LSP23' })
        }, null, 8 /* PROPS */, _hoisted_3)
      ]),
      (controllerAddress.value)
        ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
            _createVNode(Identicons, {
              class: "mt-10",
              "up-generate-l-s-p23-address-params": _unref(upGenerateLSP23AddressParams),
              eth: _unref(web3Eth),
              "controller-address": controllerAddress.value,
              "onUpdate:modelValue": updateIdenticon
            }, null, 8 /* PROPS */, ["up-generate-l-s-p23-address-params", "eth", "controller-address"])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["", `buttons`])
    }, [
      _createVNode(Button, {
        "data-testid": "cancel-button",
        variant: "text",
        "is-full-width": true,
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('select_account.button.cancel')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(Button, {
        variant: "primary",
        "is-full-width": true,
        onClick: confirmAddress
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('create_address.confirm')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}
}

})